export default __webpack_public_path__ + "static/media/backgroundRovescio.fdb347ab.jpg";